export default __webpack_public_path__ + "static/media/chart.8cce4fa5.png";